import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import ErrorTwoToneIcon from '@mui/icons-material/ErrorTwoTone';
import { useJourney } from '../../../../api/Journeys/journey_queries';
import FlowIssues from './FlowIssues';

const JourneyIssuesSidebar = ({ hideSidebar }) => {
    const { id: journeyIdStr } = useParams();
    const journeyId = parseInt(journeyIdStr);

    const { data: journey, isSuccess } = useJourney(journeyId);

    if (!isSuccess || !journey) {
        return (
            <div className='flow-sidebar' style={{width: '15vw'}}>
                <Box className='flow-sidebar__header'>
                    <Typography component='div' variant='body1' className='flow-sidebar_title no-edit'>
                        <ErrorTwoToneIcon />
                        Flow Issues
                    </Typography>
                </Box>
                <Box className='flow-sidebar__body'>
                    <Typography variant="body2" color="text.secondary" align="center" sx={{ p: 2 }}>
                        Loading issues...
                    </Typography>
                </Box>
            </div>
        );
    }

    return <FlowIssues issues={journey.activation_issues} hideSidebar={hideSidebar} />;
};

export default JourneyIssuesSidebar;
